import _ from 'lodash';
import {
    LOGIN,
    USER_LIST_PAGE_LOADED,
    MERCHANT_LIST_PAGE_LOADED,
    USER_PAGE_LOADED,
    ACCOUNT_GO,
    COIN_LIST_PAGE_LOADED,
    CONTRACT_LIST_PAGE_LOADED,
    MASTER_ACCOUNT_LIST_PAGE_LOADED,
    TASK_WITHDRAW_LOADED,
    TASK_DEPOSIT_LOADED,
    TASK_VERIFICATION_LOADED,
    TASK_KYC_LOADED,
    TASK_GEMINIORDERS_LOADED,
    TRANSACTION_LIST_PAGE_LOADED,
    TRANSACTION_LIST_EXPORT,
    TRADE_LIST_PAGE_LOADED,
    LOG_LIST_PAGE_LOADED,
    SIGNATURE_PAGE_LOADED,
    ETH_COMMIT_USER_LIST_PAGE_LOADED,
    BTC_COMMIT_USER_LIST_PAGE_LOADED,
    CHAT_CHANNEL_LIST_PAGE_LOADED,
    DEPOSIT_BANK_REFERENCE_CODE_SUBMIT,
    ACCOUNT_RESET_SYNCTIME,
    RESEND_VERIFICATION_EMAIL,
    USER_TOGGLE_MFA,
    RESET_BANK_VERIFICATION,
    RATES_PAGE_LOADED,
    RATE_CREATE_PAGE_LOADED,
    RATE_UPDATE_PAGE_LOADED,
    ACCOUNT_PAGE_LOADED,
    CATEGORY_LIST_PAGE_LOADED,
    PRODUCT_LIST_PAGE_LOADED,
    RESET_TOTP,
    USER_ROLE_UPDATED,
    UPDATE_PHONE_STATUS,
    UPDATE_LOCK_STATUS,
    VIEW_REPORTS_URL,
    UPDATE_PHONE,
    TOKEN_CREATE,
    TOKEN_UPDATE,
    TOKEN_DETAIL_PAGE_LOADED,
    TOKEN_LIST_PAGE_LOADED,
    TOKEN_APPROVE,
    TOKEN_LOGS_PAGE_LOADED
} from '../constants/actionTypes'

let roles = {
    admin: {
        id: 999,
        can: []
    },
    user: {
        id: 0,
        can: [
            // LOGIN
        ]
    },
    merchant: {
        id: 1,
        can: []
    },
    customer_service: {
        id: 10,
        can: [
            LOGIN,
            USER_LIST_PAGE_LOADED,
            VIEW_REPORTS_URL,
            CHAT_CHANNEL_LIST_PAGE_LOADED
        ]
    },
    customer_service_id_approver: {
        id: 11,
        can: [
            LOGIN,
            USER_LIST_PAGE_LOADED,
            VIEW_REPORTS_URL,
            USER_PAGE_LOADED,
            TASK_KYC_LOADED,
        ]
    },
    customer_service_bank_verifier: {
        id: 12,
        can: [
            LOGIN,
            TASK_VERIFICATION_LOADED
        ]
    },
    customer_service_bank_chat: {
        id: 13,
        can: [
            LOGIN,
            USER_TOGGLE_MFA,
            RESET_BANK_VERIFICATION
        ]
    },
    customer_service_admin: {
        id: 20,
        can: [
            LOGIN,
            USER_LIST_PAGE_LOADED,
            VIEW_REPORTS_URL,
            MERCHANT_LIST_PAGE_LOADED,
            USER_PAGE_LOADED,
            ACCOUNT_GO,
            ACCOUNT_PAGE_LOADED,
            TASK_KYC_LOADED,
            TASK_VERIFICATION_LOADED,
            COIN_LIST_PAGE_LOADED,
            TRANSACTION_LIST_PAGE_LOADED,
            TRANSACTION_LIST_EXPORT,
            LOG_LIST_PAGE_LOADED,
            USER_TOGGLE_MFA,
            RESET_TOTP,
            USER_ROLE_UPDATED,
            RESEND_VERIFICATION_EMAIL,
            UPDATE_PHONE_STATUS,
            UPDATE_LOCK_STATUS,
            UPDATE_PHONE
        ]
    },
    customer_service_user_approver: {
        id: 30,
        can: [
            LOGIN,
            USER_LIST_PAGE_LOADED,
            VIEW_REPORTS_URL,
            MERCHANT_LIST_PAGE_LOADED,
            USER_PAGE_LOADED,
            USER_TOGGLE_MFA,
            RESET_TOTP,
            USER_ROLE_UPDATED,
            RESEND_VERIFICATION_EMAIL,
            UPDATE_PHONE_STATUS,
            UPDATE_LOCK_STATUS
        ]
    },
    token_admin: {
        id: 60,
        can: [
            LOGIN,
            TOKEN_CREATE,
            TOKEN_UPDATE,
            TOKEN_DETAIL_PAGE_LOADED,
            TOKEN_LIST_PAGE_LOADED,
            TOKEN_APPROVE,
            TOKEN_LOGS_PAGE_LOADED
        ]
    }
}

// extend role to inherit other roles permissions
roles.customer_service.can = roles.customer_service.can.concat(roles.customer_service_id_approver.can);
roles.customer_service.can = roles.customer_service.can.concat(roles.customer_service_bank_verifier.can);
roles.customer_service.can = roles.customer_service.can.concat(roles.customer_service_bank_chat.can);

export default {
    isAdmin: function (roleId) {
        return roleId === roles.admin.id
    },
    isMerchant: function (roleId) {
        return roleId === roles.merchant.id
    },
    isTokenAdmin: function (roleId) {
        return roleId === roles.token_admin.id
    },
    can(role, operation) {
        //console.log(`role: ${role}, operation: ${operation}`)

        if (this.isAdmin(role))
            return true;

        let matchingRole = _.filter(roles, function (o) { return o.id === role; });

        //console.log(matchingRole[0])

        return matchingRole[0] && matchingRole[0].can.indexOf(operation) !== -1;
    }
}



// WEBPACK FOOTER //
// ./src/util/role.js